export default "__VITE_ASSET__CVLurJj8__"